// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBarHeader_searchBar__XRg2Y"};